module.exports = __webpack_public_path__ + "static/media/f-logo-outline.56828d1f.svg";